import * as settingsBarConsts from '../consts';
import type { SettingsConfig } from '@ardoq/view-settings';

export const replaceLegendButton = (
  isLegendActive: boolean,
  originalRightMenu: SettingsConfig[]
) => {
  const legendToggleIndex = originalRightMenu.findIndex(
    ({ id }) => id === settingsBarConsts.IS_LEGEND_ACTIVE
  );
  const legendToggle = {
    ...originalRightMenu[legendToggleIndex],
    isActive: isLegendActive,
  };
  return [
    ...originalRightMenu.slice(0, legendToggleIndex),
    legendToggle,
    ...originalRightMenu.slice(legendToggleIndex + 1, originalRightMenu.length),
  ];
};
